<div class="container-fluid">
    <div id="home-banner-container-1" class="home-banner-container">
        <md-dynamic-banner
            *ngIf="heroBanners$ | async as hero"
            [images]="hero[0]?.images"
            [isMobile]="isMobile$ | async"
            (bannerClick)="handleBannerClick('banner1', 0)"
            (bannerImpression)="handleBannerImpression($event, 'banner1')"
        ></md-dynamic-banner>
    </div>
    <div class="h-category-carousel h-block">
        <div
            *ngIf="
                !trendingEntries ||
                (trendingEntries && trendingEntries.length > 0)
            "
            class="h-category-title"
        >
            <h2>{{ "Trending" | translate }}</h2>
        </div>
        <ng-container *ngIf="trendingEntries">
            <div mdDesktopOnly>
                <div class="h-trending-desktop-container h-presenter">
                    <div
                        *ngFor="let dealEntry of trendingEntries"
                        class="h-trending-desktop-item"
                    >
                        <md-product-card
                            [dealEntry]="dealEntry"
                            (dealSelected)="dealSelected($event)"
                            [noBanners]="true"
                        ></md-product-card>
                    </div>
                </div>
            </div>
            <div mdMobileOnly class="h-category-carousel" id="swiper-trending">
                <swiper [config]="swiperConfigTrending" class="custom-swiper">
                    <div class="swiper-wrapper h-swiper-container">
                        <div
                            class="swiper-slide"
                            *ngFor="let dealEntry of trendingEntries"
                        >
                            <md-product-card
                                [dealEntry]="dealEntry"
                                (dealSelected)="dealSelected($event)"
                                [noBanners]="true"
                            ></md-product-card>
                        </div>
                    </div>
                </swiper>
            </div>
        </ng-container>
        <ng-container
            *ngIf="
                getBannersAtPosition('after-trending')
                    | async as trendingBanners
            "
        >
            <div class="home-banner-container">
                <md-dynamic-banner
                    *ngIf="trendingBanners.length"
                    [images]="trendingBanners[0]?.images"
                    [isMobile]="isMobile$ | async"
                    (bannerClick)="handleBannerClick('after-trending', 0)"
                    (bannerImpression)="
                        handleBannerImpression($event, 'after-trending')
                    "
                ></md-dynamic-banner>
            </div>
        </ng-container>
        <ng-container *ngIf="!trendingEntries">
            <div mdDesktopOnly>
                <div class="h-trending-desktop-container h-presenter">
                    <div
                        *ngFor="
                            let dealEntry of trendingEntriesLoadingPlaceholder
                        "
                        class="h-trending-desktop-item"
                    >
                        <md-product-card-loading />
                    </div>
                </div>
            </div>

            <div mdMobileOnly class="h-category-carousel">
                <swiper [config]="swiperConfigTrending" class="custom-swiper">
                    <div class="swiper-wrapper h-swiper-container">
                        <div
                            class="swiper-slide"
                            *ngFor="let dealEntry of [0, 1, 2]"
                        >
                            <md-product-card-loading />
                        </div>
                    </div>
                </swiper>
                <div
                    mdMobileOnly
                    class="swiper-button-next swiper-trending-button-next"
                ></div>
                <div
                    mdMobileOnly
                    class="swiper-button-prev swiper-trending-button-prev"
                ></div>
            </div>
        </ng-container>
    </div>
    <div *ngIf="bestSellerCategories">
        <div
            class="h-category-carousel h-block"
            *ngFor="
                let bestSellerCategory of bestSellerCategories.categories;
                let i = index
            "
        >
            <ng-container *ngIf="bestSellerCategory.data.length > 0">
                <div class="h-category-title">
                    <h2>
                        {{ bestSellerCategory.category | translate }}
                    </h2>
                </div>
                <div *ngIf="i === 0 || i === 1" mdDesktopOnly>
                    <div class="h-trending-desktop-container h-presenter">
                        <div
                            *ngFor="let dealEntry of bestSellerCategory.data"
                            class="h-trending-desktop-item"
                        >
                            <md-product-card
                                [dealEntry]="dealEntry"
                                (dealSelected)="dealSelected($event)"
                                [noBanners]="true"
                            ></md-product-card>
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="i === 0 || i === 1">
                    <div mdMobileOnly [attr.id]="'swiper-best-sellers-' + i">
                        <swiper
                            [config]="getSwiperConfig(i)"
                            class="custom-swiper"
                        >
                            <div
                                class="swiper-wrapper h-swiper-container h-block"
                            >
                                <div
                                    class="swiper-slide"
                                    *ngFor="
                                        let dealEntry of bestSellerCategory.data
                                    "
                                >
                                    <md-product-card
                                        [dealEntry]="dealEntry"
                                        (dealSelected)="dealSelected($event)"
                                        [noBanners]="true"
                                    ></md-product-card>
                                </div>
                            </div>
                        </swiper>
                    </div>
                </ng-container>
                <ng-container *ngIf="i >= 2">
                    <div [attr.id]="'swiper-best-sellers-' + i">
                        <swiper
                            [config]="getSwiperConfig(i)"
                            class="custom-swiper"
                        >
                            <div
                                class="swiper-wrapper h-swiper-container h-block"
                            >
                                <div
                                    class="swiper-slide"
                                    *ngFor="
                                        let dealEntry of bestSellerCategory.data
                                    "
                                >
                                    <md-product-card
                                        [dealEntry]="dealEntry"
                                        (dealSelected)="dealSelected($event)"
                                        [noBanners]="true"
                                    ></md-product-card>
                                </div>
                            </div>
                        </swiper>
                        <div
                            mdDesktopOnly
                            class="swiper-button-next swiper-best-sellers-button-next-{{
                                i
                            }}"
                        ></div>
                        <div
                            mdDesktopOnly
                            class="swiper-button-prev swiper-best-sellers-button-prev-{{
                                i
                            }}"
                        ></div>
                    </div>
                </ng-container>
            </ng-container>
            <ng-container
                *ngIf="
                    getBannersAtPosition('after-best-seller-' + i)
                        | async as dynamicBanners
                "
            >
                <div class="home-banner-container">
                    <md-dynamic-banner
                        *ngIf="dynamicBanners.length"
                        [images]="dynamicBanners[0]?.images"
                        [isMobile]="isMobile$ | async"
                        (bannerClick)="
                            handleBannerClick('after-best-seller-' + i, 0)
                        "
                        (bannerImpression)="
                            handleBannerImpression(
                                $event,
                                'after-best-seller-' + i
                            )
                        "
                    ></md-dynamic-banner>
                </div>
            </ng-container>
        </div>
    </div>
    <div
        *ngIf="!bestSellerCategories"
        class="h-category-carousel h-block"
        style="margin-bottom: 100px"
    >
        <div class="h-category-title">
            <h2>
                {{ "Hotels" | translate }}
            </h2>
        </div>
        <swiper [config]="swiperConfig" class="custom-swiper">
            <div class="swiper-wrapper h-swiper-container">
                <div
                    class="swiper-slide"
                    *ngFor="let dealEntry of getRepeatArray(5)"
                >
                    <md-product-card-loading />
                </div>
            </div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
        </swiper>
    </div>
</div>
